const INFO = {
	main: {
		title: "Hamoun Dolatshahi",
		name: "Hamoun Dolatshahi",
		email: "hamoun.dolatshahi@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://twitter.com/",
		github: "https://github.com/",
		linkedin: "https://linkedin.com/",
		instagram: "https://instagram.com/hamouniran/",
		facebook: "https://facebook.com/",
	},

	homepage: {
		title: "Filmmaker and Founder.",
		description1:
			"Hamoun Dolatshahi is a Kurdish-Iranian filmmaker and the founder and CEO of Zagros Film LLC, a Los Angeles-based studio dedicated to creating, developing, and funding bold new stories for both film and television. Born in the Kurdish city of Kermanshah, Iran, Hamoun came to the United States as a refugee in 2010. His work explores identity, migration, and the nuances of cultural navigation in the diaspora.\n\n Through Zagros Film, Hamoun is building a creative hub with multiple fronts—developing original IP for Film and TV while offering high-quality production services across narrative, commercial, and branded content. His mission is to uplift unheard voices and craft visually striking, emotionally resonant work that challenges and inspires.",
		description2: "\n\n He earned his BA in Communication from UC San Diego and his MFA in Directing and Producing from UCLA’s School of Theater, Film, and Television. His directing credits include five short films, a TV spec, and several music videos. He has also served as a producer and assistant director on numerous indie and student projects, and most recently contributed as assistant producer/director on the A24/Netflix series BEEF.\n\n An active community advocate, Hamoun organizes within refugee and immigrant circles, using his platform to promote justice and equity. He believes in the power of storytelling to shift culture and center the lived experiences of real people.\n\n His latest work includes JIN (2024), his UCLA thesis film and winner of the prestigious Sloan Film Grant. The film explores themes of artificial general intelligence, language ethics, and Kurdish feminist theory. Additional projects include Nothing But the Truth (2024), Application (2023), and Fourcorners (2024), each grounded in social relevance and driven by purpose."
	},

	writer: [
		{
			id: "1",
			title: "✏️ Seeking Refuge - Feature",
			description:
				"In this humorous, slice-of-life, coming-of-age, a Kurdish teenage refugee works as a dishwasher in the most toxic and high-end restaurant in all of Torrance, CA. As he struggles to support his defiant single mother and two sisters, he makes unlikely friendships on a goose chase for whiteness and girls in this exploration of masculinity and community.",
			evaluation: "This script offers a raw, honest, and emotionally grounded portrait of a working-class immigrant life, in the vein of a BLUE BAYOU. With the right talent and filmmaker attached, it could be a solid contender for festivals like Sundance or Tribeca. Filmmakers like Chloé Zhao, Fernando Frías, or Eliza Hittman could potentially serve as compelling north stars in terms of tone and execution. The strong sense of place, coming-of-age undertones along, and clear thematic core also make it a more natural fit for prestige-leaning distributors like A24 or Magnolia. That being said, the naturalistic, slice-of-life pacing and structure may pose challenges from a financing perspective unless the emotional arc is sharpened and the midpoint-to-third-act progression gains more narrative urgency."
		},
		{
			id: "2",
			title: "✏️ JIN - Feature in Development",
			description:
				"",
		},
	],

	actor: {
		title: "Acting...",
		description:
			"My work on screen is a reflection of my passion for storytelling and my commitment to bringing authentic, nuanced characters to life. I strive to embody roles that challenge societal norms and offer fresh perspectives on the human experience. My approach is deeply collaborative, working closely with directors and fellow actors to create a cohesive vision that resonates with audiences.",
		jobs: [
			{ title: "Detective Rahim", image: "../images/actor/unnamed.jpg" },
			{ title: "Cafe Owner", image: "../images/actor/unnamed-2.jpg" },
			{ title: "Revolutionary Poet", image: "../images/actor/unnamed-2.png" },
			{ title: "Border Guard", image: "../images/actor/unnamed-3.jpg" },
			{ title: "Runaway Groom", image: "../images/actor/unnamed-3.png" },
			{ title: "Taxi Driver", image: "../images/actor/unnamed-4.jpg" },
			{ title: "Silent Prophet", image: "../images/actor/unnamed-4.png" },
			{ title: "Underground DJ", image: "../images/actor/unnamed-5.png" },
			{ title: "Smuggler's Son", image: "../images/actor/unnamed.png" },
		],
	},

	producer: [
		{
			title: "BEEF",
			details: "A24 / Netflix Short Film | Assistant to Director/Producers | Jan 2022 - June 2022",
			description:
				"Managed all logistics and scheduling for Director HIKARI, EP Jake Schreier, and Producer Matthew Medlin. Created detailed, color-coded script breakdowns.",
		},
		{
			title: "I Have My Father’s Feet",
			details: "UCLA Thesis Film | Producer | Jan – Mar 2024",
			description:
				"Managed all aspects of production, including hiring cast and crew, negotiating contracts, scheduling, and overseeing logistics from preproduction through shoot.",
		},
		{
			title: "Gardeners",
			details: "Sloan Winner Short Film | Producer | Sept 2024",
			description:
				"Won the Sloan Science in Cinema Filmmaker Fellowship. Led pre-production planning, budgeting, and scheduling for a large-scale stage build. Managed on-set logistics and production flow, completing the ambitious project on time and within budget.",
		},
		
	],

	editor: [
    {
      title: "Weekend In Taipei - Trailer",
      thumbnail: "/images/editor/weekendInTaipe.jpeg", // public/ path or import
      src: "/videos/editor/weekendInTaipe.mp4",
    },
    {
      title: "Four Corners — Trailer",
      thumbnail: "/images/editor/fourcorners.png", // public/ path or import
      src: "/videos/editor/fourcorners.mp4",
    },
	{
      title: "JIN - Feature in Development",
      thumbnail: "/images/editor/jin.png",
      src: "/videos/editor/jin.mp4",
    },
	{
      title: "To Freedom — Performance Art",
      thumbnail: "/images/editor/toFreedom.png",
      src: "https://www.youtube.com/watch?v=GsI_YhOilwg",
    },
	{
      title: "Azar — Music Video",
      thumbnail: "/images/editor/azar.png",
      src: "https://www.youtube.com/watch?v=PK0HX0Xz8IA",
    },
  ],

	projects: [
		{
			title: "To Freedom",
			linkText: "View Project",
			projectCover: "/images/editor/toFreedom.png",
			gallery: [
				{ type: "youtube", src: "GsI_YhOilwg" },
				{ type: "video", src: "/videos/director/toFreedom/bs1.mp4" },
				{ type: "video", src: "/videos/director/toFreedom/bs2.mp4" },
			],
		},

		{
			title: "Azar",
			linkText: "View Project",
			projectCover: "/images/editor/azar.png",
			gallery: [
				{ type: "youtube", src: "PK0HX0Xz8IA" },
				{ type: "video", src: "/videos/director/azar/bs1.mov" },
				{ type: "video", src: "/videos/director/azar/bs2.mov" },
				{ type: "video", src: "/videos/director/azar/bs3.mov" },
				{ type: "video", src: "/videos/director/azar/bs4.mov" },
			],
		},

		{
			title: "JIN",
			linkText: "View Project",
			projectCover: "/images/editor/jin.png",
			gallery: [
				{ type: "video", src: "/videos/editor/jin.mp4" },
				{ type: "image", src: "/images/director/jin/bs4.jpg" },
				{ type: "image", src: "/images/director/jin/bs2.jpg" },
				{ type: "video", src: "/videos/director/jin/bs2.mp4" },
				{ type: "image", src: "/images/director/jin/bs3.jpg" },
				{ type: "image", src: "/images/director/jin/bs1.jpg" },
			],
		},

		{
			title: "Nothing But the Truth",
			linkText: "View Project",
			projectCover: "/images/director/nbtt/nbtt.png",
			gallery: [
				{ type: "image", src: "/images/director/nbtt/bs1.png" },
				{ type: "image", src: "/images/director/nbtt/bs2.png" },
				{ type: "image", src: "/images/director/nbtt/bs3.png" },
				{ type: "image", src: "/images/director/nbtt/bs4.png" },
				{ type: "image", src: "/images/director/nbtt/bs5.png" },
				{ type: "image", src: "/images/director/nbtt/bs6.png" },
				{ type: "image", src: "/images/director/nbtt/bs7.png" },
			],
		},
	],
};

export default INFO;
